/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_ApprovedInputs */

const en_scene_backstage_approved = /** @type {(inputs: Scene_Backstage_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved · Atelier sees it now`)
};

/**
* | output |
* | --- |
* | "Approved · Atelier sees it now" |
*
* @param {Scene_Backstage_ApprovedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_approved = /** @type {((inputs?: Scene_Backstage_ApprovedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_ApprovedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_approved(inputs)
});